import React, { useEffect, useState } from "react";
import {
  AppBar,
  Stack,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SubMenu from "../atoms/SubMenu";
import { useContext } from "react";
import { AuthContext } from "../../Auth/Context";
import { useNavigate } from "react-router-dom";
import stylesNavbar from "../../styles/Organisms/Navbar/Navbar";
import { useTranslation } from "react-i18next";
import "../../Traduccion_ES_EN/i18nMiCuenta";
import useWexClient from "../../hooks/Clients/wexClient,";
import { rgbToHex } from "@mui/material";

function Navbar({ forceWhiteBackground = false }) {
  const { payload, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const userName = payload?.profile?.name || "";
  const [isScrolling, setIsScrolling] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { t } = useTranslation();
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 1243);
  const { getStatusAgent } = useWexClient();
  const [nameRegion, setNameRegion] = useState("");

  const handleResize = () => {
    setIsLargeScreen(window.innerWidth > 1243);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 2) {
        setIsScrolling(true);
      } else {
        setIsScrolling(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const updateStatus = async (option) => {
    try {
      const body = {
        agent: payload._id,
        status: option,
        socketID: "",
        consumer: false,
        queue: "",
      };

      await getStatusAgent(body);
    } catch (err) {
      console.log("error", err.message);
    }
  };

  const loggoutSession = async () => {
    await updateStatus("offline");
    logout();
    window.location.reload();
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const menuOptions =
    payload.profile.typeAgent !== "_CALLS_"
      ? [
          { label: t("Welcome.text142"), link: "/option-dashboard" },
          {
            label: t("Welcome.text143"),
            link: `/option-service/${sessionStorage.getItem("SelectedOption")}`,
          },
          { label: t("Welcome.text73"), link: "/cabin" },
          { label: t("Welcome.text60"), link: "/buscador" },
        ]
      : [{ label: t("Welcome.text142"), link: "/agents-home" }];

  const menuOptionsAdmin =
    payload.profile.typeAgent !== "_CALLS_"
      ? [
          { label: t("Welcome.text1"), link: "/mi-cuenta" },
          /* { label: t("Welcome.text10"), link: "/mis-servicios" }, */
        ]
      : [{ label: t("Welcome.text1"), link: "/mi-cuenta" }];

  const applyScrollStyles = isScrolling || forceWhiteBackground;

  const handleClick = () => {
    navigate("/option-dashboard");
  };

  useEffect(() => {
    if (!payload) return;

    const regions = payload.detailRegions
      ?.map((region) => region.name)
      .join(", ");

    setNameRegion(regions);
  }, [payload]);

  return (
    <AppBar
      style={{
        ...stylesNavbar.appBar,
        ...(applyScrollStyles ? stylesNavbar.appBarScrolling : {}),
      }}
    >
      {!isLargeScreen ? (
        <Stack direction="row" sx={{ width: "100vw" }}>
          <Stack
            sx={{ width: "50%", alignItems: "start", padding: "1rem 1.5rem" }}
          >
            {payload.profile.typeAgent !== "_CALLS_" && (
              <>
                <a
                  href="/option-dashboard"
                  id="logo"
                  style={{
                    ...stylesNavbar.textBlue,
                    ...(applyScrollStyles
                      ? stylesNavbar.textBlueScrolling
                      : {}),
                  }}
                  onClick={handleClick}
                >
                  {t("Welcome.text303")}
                </a>
              </>
            )}
          </Stack>
          <Stack
            sx={{ width: "50%", alignItems: "end", padding: "1rem 1.5rem" }}
          >
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer}
              sx={{
                ...stylesNavbar.textBlue,
                ...(applyScrollStyles ? stylesNavbar.textBlueScrolling : {}),
                marginRight: "8px",
                marginTop: "-0.5rem",
              }}
            >
              <MenuIcon />
            </IconButton>
          </Stack>
        </Stack>
      ) : (
        <Stack sx={{ alignItems: "center" }}>
          <Stack
            direction="row"
            style={{
              justifyContent: "space-between",
              flexWrap: "wrap",
              width: "60%",
            }}
          >
            <Stack sx={stylesNavbar.stack}>
              <a
                onClick={handleClick}
                id="logo"
                style={{
                  ...stylesNavbar.textBlue,
                  ...(applyScrollStyles ? stylesNavbar.textBlueScrolling : {}),
                  position: "fixed",
                }}
              >
                {t("Welcome.text303")}
              </a>
            </Stack>
            <Stack
              sx={{ ...stylesNavbar.stack, margin: "10px", marginTop: "5px" }}
              direction="row"
              style={{ flexWrap: "wrap", alignItems: "center" }}
            >
              {menuOptions.map((option, index) => (
                <a
                  key={index}
                  href={option.link}
                  className="active"
                  style={{
                    ...stylesNavbar.a,
                    ...(applyScrollStyles ? stylesNavbar.aScrolling : {}),
                    marginLeft: "20px",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.color = stylesNavbar.aHover.color)
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.color = applyScrollStyles
                      ? stylesNavbar.aScrolling.color
                      : stylesNavbar.a.color)
                  }
                >
                  {option.label}
                </a>
              ))}

              <a style={stylesNavbar.b}>
                <SubMenu
                  user={userName}
                  loggout={() => loggoutSession()}
                  showLogoutOption={true}
                  menuOptions={menuOptionsAdmin}
                  isScrolling={applyScrollStyles}
                />
              </a>
            </Stack>
          </Stack>
        </Stack>
      )}

      {!isLargeScreen && (
        <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer}>
          <List>
            <ListItem>
              <a>
                <SubMenu
                  user={userName}
                  loggout={() => loggoutSession()}
                  showLogoutOption={true}
                  menuOptions={menuOptionsAdmin}
                  color="#0979b0"
                />
              </a>
            </ListItem>
            {menuOptions.map((option, index) => (
              <ListItem
                key={index}
                button
                onClick={() => navigate(option.link)}
              >
                <ListItemText primary={option.label} />
              </ListItem>
            ))}
            <Divider />
          </List>
        </Drawer>
      )}
    </AppBar>
  );
}

export default Navbar;
